function Checkout(){
    return (
        <div>
            This is Checkout
        </div>
    )
}

export default Checkout